import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import {CleanUrl} from "../../../utils/cleanUrl";

const ModalReceiptUpload = (props) => {
    const { handleModal } = props;
    const { t, i18n } = useTranslation();
    const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}/`);

    return (
        <Modal>
            <div className="pweu-modal-overlay">
                <div className="pweu-modal">
                    <div className="pweu-close-modal" onClick={handleModal}>
                        <img src={imagePath + "delete--white.svg"} alt="" />
                    </div>
                    <div className="pweu-modal-content">
                        <h2 className='heading5'>{t("Capture your receipt")}</h2>
                        <div className='pweu-modal-grid'>
                            <div className='pweu-modal-item'>
                                <div className='pweu-modal-item--img'>
                                    <img src={imagePath + "invoice.png"} alt="" />
                                </div>
                                <div className='pweu-modal-item--text'>
                                    <p>{t("Make sure your store information, date, item, name, price and receipt total are visible.")}</p>
                                    <span>{t("Select file in JPG format.")}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ModalReceiptUpload;
